import { cloneDeep } from "lodash";
import { useQueryClient } from "react-query";

const useUpdateLocalQueryData = () => {
  const queryClient = useQueryClient();

  const deleteItemFromPaginatedLocal = (key, conditionFunc) => {
    const allItems = cloneDeep(queryClient.getQueryData(key));
    const pages = allItems?.pages ?? [];
    const itemsToDelete = [];

    for (let indexPage = 0; indexPage < pages.length; indexPage += 1) {
      const currentPage = pages[indexPage];
      const pageData = currentPage.data ?? [];

      allItems.pages[indexPage].data = pageData.filter(
        (currentItem, index) => !conditionFunc(currentItem, index)
      );
    }

    queryClient.setQueryData(key, allItems);
  };

  return { deleteItemFromPaginatedLocal };
};

export default useUpdateLocalQueryData;
